module.exports = __webpack_public_path__ + "img/bell-alt.88ebfc17.svg";